import React from "react";
import { Divide as Hamburger } from "hamburger-react";
import { CiSearch } from "react-icons/ci";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import Logo from "../images/IMG.PNG";
import { NavLink } from "react-router-dom";

const Navbar = ({ menuOpen, toggleMenu }) => {
  const handleMenuClose = () => {
    if (menuOpen) toggleMenu();
  };

  return (
    <>
      <div
        className={`absolute w-full right-0 lg:h-[86.5dvh] md:h-[87dvh] h-[85dvh] bottom-0 bg-[#f8f8f8] flex z-30 text-black items-center justify-between flex-col gap-4 transition-opacity duration-1000 ${
          menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        style={{ transitionProperty: "opacity, z-index" }}
      >
        <div className="flex gap-5 items-center justify-center w-[30%] border-b border-black py-5">
          <a href="https://www.instagram.com/yogabyjasmin?igsh=MWN5eWd4dHRtdTQwMg%3D%3D&utm_source=qr">
            <FaInstagram size={26} color="#ff3289" />
          </a>
          <a href="https://www.facebook.com/PanagJasmin?mibextid=LQQJ4d">
            <FaFacebook size={26} color="#0765ff" />
          </a>
          <a href="https://youtube.com/@yogabyjasmin?si=_WT6RRkH0OXA4zDz">
            <FaYoutube size={26} color="#ff0000" />
          </a>
        </div>
        <div className="flex flex-col items-center justify-center">
          <NavLink
            to="/"
            className="font-font2 text-[36px] text-[#a7857a]"
            onClick={handleMenuClose}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className="font-font2 text-[36px] text-[#dbc7ab]"
            onClick={handleMenuClose}
          >
            About
          </NavLink>
          <NavLink
            to="/shopping"
            className="font-font2 text-[36px] text-[#6d806b]"
            onClick={handleMenuClose}
          >
            Shopping Page
          </NavLink>
          <NavLink
            to="/retreats"
            className="font-font2 text-[36px] text-[#f6bba7]"
            onClick={handleMenuClose}
          >
            Retreats
          </NavLink>
          <NavLink
            to="/gallery"
            className="font-font2 text-[36px] text-[#cfab9d]"
            onClick={handleMenuClose}
          >
            Gallery
          </NavLink>

          <NavLink
            to="/contact"
            className="font-font2 text-[36px] text-[#dbc7ab]"
            onClick={handleMenuClose}
          >
            Contact us
          </NavLink>
        </div>
        <div className="flex gap-5 items-center justify-center  mb-5">
          <p className="text-[30px] text-[#9e9a85] ">Body Meets Soul</p>
        </div>
      </div>

      <div className="w-full h-full flex flex-col items-center justify-center bg-white">
        <div className="w-[90%] h-[12dvh] md:border-b-[1px] border-black my-3 items-center justify-between relative flex">
          <div
            className="flex items-center justify-center gap-5 z-30"
            onClick={toggleMenu}
          >
            <Hamburger size={27} toggled={menuOpen} />
            <CiSearch size={22} className=" hidden" />
          </div>

          <a
            href="/"
            className="flex  stretch-logo items-center cursor-pointer  justify-center h-20 absolute right-[45%] left-[45%]"
          >
            <img src={Logo} alt="" className="h-full  object-fill" />
          </a>

          <div className="md:flex hidden items-center gap-6 justify-center">
            <a href="https://www.instagram.com/yogabyjasmin?igsh=MWN5eWd4dHRtdTQwMg%3D%3D&utm_source=qr">
              <FaInstagram size={26} color="#ff3289" />
            </a>
            <a href="https://www.facebook.com/PanagJasmin?mibextid=LQQJ4d">
              <FaFacebook size={26} color="#0765ff" />
            </a>
            <a href="https://youtube.com/@yogabyjasmin?si=_WT6RRkH0OXA4zDz">
              <FaYoutube size={26} color="#ff0000" />
            </a>
          </div>
          <div className="hidden  items-center justify-center">
            <CiSearch size={22} />
          </div>
        </div>

        <div className="w-[90%] justify-center items-center gap-10 lg:flex hidden my-2">
          <NavLink to="/" className="font-worksans text-[16px]">
            Home
          </NavLink>
          <NavLink to="/about" className="font-worksans text-[16px]">
            About Me
          </NavLink>
          <NavLink to="/retreats" className="font-worksans text-[16px]">
            Retreats
          </NavLink>
          <NavLink to="/contact" className="font-worksans text-[16px]">
            Contact us
          </NavLink>
            <NavLink to="/gallery" className="font-worksans text-[16px]">
            Gallery
          </NavLink>
          <NavLink to="/shopping" className="font-worksans text-[16px]">
            Shopping Page
          </NavLink>
        
        </div>
      </div>
    </>
  );
};

export default Navbar;
